import { makeAutoObservable } from "mobx";
import { EmptyRegistrationUserObservableRequestImpl } from "../DTO/User";
import UserServerClient from "../ServerClients/UserServerClient";

export class RegistrationStore {
  private newUser: EmptyRegistrationUserObservableRequestImpl;
  private confirmPassword: string;

  constructor() {
    this.newUser = new EmptyRegistrationUserObservableRequestImpl();
    this.confirmPassword = "";
    makeAutoObservable(this);
  }

  public onChangeConfirmPassword = (
    event: React.FormEvent<HTMLInputElement>
  ) => {
    this.confirmPassword = event.currentTarget.value;
  };

  public onChangeUserName = (event: React.FormEvent<HTMLInputElement>) => {
    this.newUser.onChangeName(event.currentTarget.value);
  };

  public onChangeUserMail = (event: React.FormEvent<HTMLInputElement>) => {
    this.newUser.onChangeMail(event.currentTarget.value);
  };

  public onChangeUserPassword = (event: React.FormEvent<HTMLInputElement>) => {
    this.newUser.onChangePassword(event.currentTarget.value);
  };

  public registrateUser = () => {
    if (this.confirmPassword !== this.newUser.password) {
      alert("Пароли не совпадают");
    } else {
      return UserServerClient.sendToRegistrateUserAsync(this.newUser);
    }
  };
}
